<template>
  <div class="my-2">
    <b-row class="justify-content-center align-items-center">
      <b-col v-for="(link, n) in links" :key="n" xl="4" lg="6" v-if="checkIsItemGroup(link)">
        <b-card style="height: 260px">
          <b-card-title class="mb-3 d-flex align-items-center">
            <feather-icon size="16" class="mr-50" icon="GridIcon" />
            {{ link.title }}
          </b-card-title>
          <b-form-row class="mt-5">
            <b-col
              v-can="{ slug: btn.slug, action: 'S' }"
              v-for="(btn, n) in link.btns"
              v-if="checkIsItem(btn.slug)" 
              :key="n"
              xl="4"
              lg="6"
            >
              <router-link :to="`/ministry/ngos-data-new/${btn.linkSlug}`">
                <div
                  class="ngos-link d-flex flex-column align-items-center px-2"
                >
                  <img
                    style="height: 65px; color: azure"
                    class="text-white"
                    :src="btn.icon"
                    alt=""
                  />
                  <h5 class="text-white">{{ btn.label }}</h5>
                </div>
              </router-link>
            </b-col>
          </b-form-row>
        </b-card>
      </b-col>
    </b-row>
    <router-link to="/ministry/advanced-reports" class="advanced-report" v-can="{ slug: 'ministry_advanced_reports', action: 'C' }">
      <b-button variant="info" size="lg">
        <feather-icon size="20" icon="PlusIcon" />
        إنشاء تقرير متقدم</b-button
      >
    </router-link>
  </div>
</template>

<script>
import AuthHelpers from "@/utils/auth-helpers";
import {
  BRow,
  BFormRow,
  BContainer,
  BCol,
  BAvatar,
  BCard,
  BCardTitle,
  BCardText,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BFormRow,
    BContainer,
    BCol,
    BAvatar,
    BCard,
    BCardTitle,
    BCardText,
    BButton,
  },

  data() {
    return {
      links: [
        {
          title: "المعلومات الأساسية",
          btns: [
            {
              label: "المنظمات",
              slug: "ministry_ngos_management",
              linkSlug: "ngos",
              icon: require("@/assets/images/ngos-data/organizations.svg"),
            },
            // {
            //   label: "تصنيفات المنظمات",
            //   slug: "ministry_categories_management",
            //   linkSlug: "classifications",
            //   icon: require("@/assets/images/ngos-data/category.svg"),
            // },

            // {
            //   label: "خدمات المنظمات",
            //   slug: "ministry_services_management",
            //   linkSlug: "services",
            //   icon: require("@/assets/images/ngos-data/organizations-services.svg"),
            // },
            {
              label: "الفروع",
              slug: "ministry_branches_management",
              linkSlug: "branches",
              icon: require("@/assets/images/ngos-data/Branches.svg"),
            },
            {
              label: "المراكز الخدمية",
              slug: "ministry_service_centres_management",
              linkSlug: "serviceCentres",
              icon: require("@/assets/images/ngos-data/services-center.svg"),
            },
            // {
            //   label: "معلومات التواصل",
            //   slug: "ministry_contact_information_management",
            //   linkSlug: "contacts",
            //   icon: require("@/assets/images/ngos-data/contact-information.svg"),
            // },
          ],
        },
        {
          title: "المعلومات البنكية",
          btns: [
            {
              label: "الحسابات البنكية",
              slug: "ministry_bank_accounts_management",
              linkSlug: "bankAccounts",
              icon: require("@/assets/images/ngos-data/bank-accounts.svg"),
            },
            {
              label: "محركي الحسابات",
              slug: "ministry_account_managers_management",
              linkSlug: "accountManagers",
              icon: require("@/assets/images/ngos-data/account-managers.svg"),
            },
          ],
        },
        {
          title: "الممتلكات",
          btns: [
            {
              label: "العقارات",
              slug: "ministry_real-estates_management",
              linkSlug: "realEstates",
              icon: require("@/assets/images/ngos-data/real-estates.svg"),
            },
            {
              label: "الآليات",
              slug: "ministry_machines_management",
              linkSlug: "machines",
              icon: require("@/assets/images/ngos-data/vehicles.svg"),
            },
          ],
        },
        {
          title: "الوضع الإداري و التنظيمي",
          btns: [
            // {
            //   label: "مجلس الإدارة",
            //   slug: "ministry_administration_management",
            //   linkSlug: "administrators",
            //   icon: require("@/assets/images/ngos-data/administrators.svg"),
            // },
            // {
            //   label: "المجلس التأسيسي",
            //   slug: "ministry_founders_management",
            //   linkSlug: "founders",
            //   icon: require("@/assets/images/ngos-data/founders.svg"),
            // },
            // {
            //   label: "مجلس الأمناء",
            //   slug: "ministry_trustees_board_management",
            //   linkSlug: "trustees",
            //   icon: require("@/assets/images/ngos-data/trustees.svg"),
            // },
            // {
            //   label: "الإدارة التنفيذية",
            //   slug: "ministry_executives_management",
            //   linkSlug: "executives",
            //   icon: require("@/assets/images/ngos-data/executive-management.svg"),
            // },
            {
              label: "الموظفين",
              slug: "ministry_employees_management",
              linkSlug: "employees",
              icon: require("@/assets/images/ngos-data/employees.svg"),
            },
            // {
            //   label: "المتطوعين",
            //   slug: "ministry_volunteers_management",
            //   linkSlug: "volunteers",
            //   icon: require("@/assets/images/ngos-data/volunteers.svg"),
            // },
          ],
        },
        {
          title: "البرامج و الأنشطة",
          btns: [
            {
              label: "البرامج",
              slug: "ministry_programs_management",
              linkSlug: "programs",
              icon: require("@/assets/images/ngos-data/programs.svg"),
            },
            {
              label: "الأنشطة",
              slug: "ministry_activities_management",
              linkSlug: "activities",
              icon: require("@/assets/images/ngos-data/activities.svg"),
            },
            // {
            //   label: "الخطة السنوية",
            //   slug: "ministry_plans_management",
            //   linkSlug: "plans",
            //   icon: require("@/assets/images/ngos-data/annual-plan.svg"),
            // },
          ],
        },
        {
          title: "واجهات الجمهور",
          btns: [
            {
              label: "حملات التبرع",
              slug: "ministry_campaigns_management",
              linkSlug: "campaigns",
              icon: require("@/assets/images/ngos-data/campaigns.svg"),
            },
            {
              label: "الفرص",
              slug: "ministry_opportunities_management",
              linkSlug: "opportunities",
              icon: require("@/assets/images/ngos-data/jobs.svg"),
            },
            // {
            //   label: "فرص التطوع",
            //   slug: "ministry_opportunities_management",
            //   linkSlug: "opp-volunteer",
            //   icon: require("@/assets/images/ngos-data/volunteer.svg"),
            // },
            // {
            //   label: " الفعاليات ",
            //   slug: "ministry_events_management",
            //   linkSlug: "events",
            //   icon: require("@/assets/images/ngos-data/events.svg"),
            // },
            {
              label: "أخبار المنظمة",
              slug: "ministry_news_management",
              linkSlug: "news",
              icon: require("@/assets/images/ngos-data/news.svg"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    checkIsItem(slug) {
      return AuthHelpers.canNavigate(slug);
    },
    checkIsItemGroup(item) {
      return item.btns.some((el) => AuthHelpers.canNavigate(el.slug));
    },
  },
};
</script>

<style lang="scss" scoped>
.advanced-report {
  position: fixed;
  bottom: 6%;
  z-index: 1031;
  right: 1%;
}
.ngos-link {
  background-color: var(--primary);
  padding: 4px;
  color: var(--white);
  text-align: center;
  white-space: nowrap;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.85;
    -webkit-box-shadow: 0 8px 25px -8px var(--primary);
    box-shadow: 0 8px 25px -8px var(--primary);
  }

  &:active {
    background-color: #043d6e;
  }
}
</style>
